export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10400.4d371072.jpg";